<template>
  <content-items-view
    content-type="galleries"
    content-type-singular="gallery"
    content-name="Galleries"
    content-name-singular="Gallery"
  />
</template>

<script>
import ContentItemsView from '@/views/content-item/content-items-view/ContentItemsView.vue'

export default {
  components: {
    ContentItemsView,
  },
}
</script>

<style scoped>

</style>
